const QUERY_KEYS = {
  ACCOUNT_ROOTS: 'account_roots',
  PROFILE: {
    PROFILE: 'profile',
    SHOOTER_PROFILE: 'shooter_profile',
  },
  BIOMETRIC_DATA: 'biometric_data',
  DASHBOARD: {
    SCORES: 'scores',
    RANKINGS: 'rankings',
    TOTAL_TRAIN_TIME: 'total_train_time',
    WORST_PRESENTATION: 'worst_presentation',
  },
  VCAT_KITS: 'vcat_kits_data',
  MANAGED_USERS: 'managed_users',
  SCENARIO_USAGE: 'scenario_usage',
  ACTIVE_SESSIONS: 'active_sessions',
  SHOOTING_DATA: {
    SESSIONS: 'sessions',
    SCENARIOS: 'scenarios',
    REPETITIONS: 'repetitions',
    TRANSACTIONS: 'transactions',
    WEAPON_PRESENTATION: 'weapon_presentation',
    STABILITY_PRESENTATION: 'stability_presentation',
  },
  CATALOG: {
    ITEMS: 'items',
    WEAPONS: 'weapons',
    NEXT_TRAINING: 'next_training',
    ITEMS_COLLECTIONS: 'items_collections'
  },
  ASSIGNMENT: 'assignment'
} as const;

const PERSIST_KEYS = {
  PROFILE_DATA: 'profile_data',
  CATALOG_DATA: 'catalog_data',
  SHOOTING_DATA: 'shooting_data',
  DASHBOARD_DATA: 'dashboard_data',
  VCAT_KITS_DATA: 'vcat_kits_data',
  ASSIGNMENT_DATA: 'assignment_data',
  MANAGED_USERS_DATA: 'managed_users_data',
  ACCOUNT_ROOTS_DATA: 'account_roots_data',
  SCENARIO_USAGE_DATA: 'scenario_usage_data',
  BILLING_REPORT_DATA: 'billing_report_data',
  ACTIVE_SESSIONS_DATA: 'active_sessions_data',
} as const;

const STORE_SLICES = {
  PROFILE_DATA: 'profile_data',
  CATALOG_DATA: 'catalog_data',
  SHOOTING_DATA: 'shooting_data',
  VCAT_KITS_DATA: 'vcat_kits_data',
  DASHBOARD_DATA: 'dashboard_data',
  ASSIGNMENT_DATA: 'assignment_data',
  MANAGED_USERS_DATA: 'managed_users_data',
  ACCOUNT_ROOTS_DATA: 'account_roots_data',
  SCENARIO_USAGE_DATA: 'scenario_usage_data',
  BILLING_REPORT_DATA: 'billing_report_data',
  ACTIVE_SESSIONS_DATA: 'active_sessions_data',
} as const;

export { QUERY_KEYS, PERSIST_KEYS, STORE_SLICES };